import { render, staticRenderFns } from "./ProblemSetEvaluationManage.vue?vue&type=template&id=8d79972c"
import script from "./ProblemSetEvaluationManage.vue?vue&type=script&lang=ts"
export * from "./ProblemSetEvaluationManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports